import styled from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";

export const PageContainer = styled(PageWrapper)`
  box-sizing: border-box;

  &.app-content .content-holder .page-heading {
    z-index: 0;
  }

  @media (min-width: 1260px) {
    &.app-content .content-holder {
      padding-top: 0;
      padding-bottom: 0px;
      height: 100%;
      overflow: hidden;
    }
  }
`;

export const PageContent = styled.div`
  width: 100%;
  flex: 1;
  height: 100%;
  display: grid;
  grid-template-rows: 132px 1fr;
  grid-template-columns: 1fr 350px;
  padding-bottom: 2px !important;
  padding: 0;
  box-sizing: border-box;

  @media (min-width: 1600px) {
    grid-template-columns: 1fr 420px;
  }

  .edit-blocked {
    grid-row: 1/4;
    grid-column: 1/3;

    h3 {
      color: var(--color-purple);
    }
  }
`;

export const PageHeading = styled.div`
  grid-row: 1/2;
  grid-column: 1/2;
  width: auto;
  padding:0 5px;
  border-right: 1px solid #c4c4c4;


  h5 {
    font-family: var(--font-display);
    font-size: 15px;
    font-weight: 500;
    color: var(--color-gray-text);
    line-height: 22px;
  }

  p {
    font-family: var(--font-display);
    color: var(--color-purple);
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    font-weight: 600;
  
`;

export const PageBody = styled.div`
  padding: 0;
  padding-right: 20px;
  grid-row: 1/3;
  grid-column: 1/3;
  width: 100%;

  display: grid;
  grid-template-rows: 132px 1fr;
  grid-template-columns: 1fr 371px;

  .card-search-information {
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 20px;

    grid-column: 1/2;
    grid-row: 2/3;
    margin: 0;
  }

  .cart-information-resume {
    grid-column: 2/3;
    grid-row: 1/3;

    border-top: none;
    padding: 20px 20px;
    padding-right: 0;
    border-left: 1px solid #c4c4c4;
    position: unset;
    width: auto;
    padding-right: 0;
  }

  @media (min-width: 1600px) {
    grid-template-columns: 1fr 550px;
  }
`;

export const Cart = styled.div`
  grid-column: 2/3;
  grid-row: 1/3;

  h5 {
    margin-top: 15px;
    color: var(--color-purple);
  }

  .tabs {
    display: flex;
    display: grid;
    grid-template-columns: 1fr 1fr;

    button {
      border-radius: 0;
      background: transparent;
      color: var(--color-purple);
      font-weight: 600;

      &.active {
        background: var(--color-purple);
        color: white;
      }
    }
  }

  .tab-item {
    padding: 0 10px;

    &.patient-info {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }

    .patient,
    .schedule,
    .address {
      display: flex;
      flex-direction: column;
      gap: 5px;

      h3 {
        font-size: 1.2rem;
        color: var(--color-purple);
        margin-bottom: 0;
      }

      .item {
        display: flex;
        align-items: center;
        gap: 5px;

        .bold {
          font-weight: 600;
        }

        span {
          font-size: 0.8rem;
        }

        .PhoneInput {
          padding: 1px 10px;
          width: 100%;
        }
        .field-holder {
          width: 100%;

          &.field-holder-invalid .error-message {
            position: initial;
          }

          input {
            padding: 1px 10px;
          }
        }
      }
    }
  }

  .edit-btn {
    border-radius: 8px;
    padding: 5px 10px;
  }

  .cart-buttons {
    margin-top: 20px;
    padding: 0 10px;
    gap: 5px;
    display: flex;
    flex-direction: column;
  }
`;

export const Container = styled.div`
  padding-bottom: 20px;
  height: 100%;
  background: #f5f5f5;
  padding: 0 10px;
  grid-column: 1/2;
  grid-row: 2/3;
  margin: 0;
  width: 100%;
  display: block;
  padding: 0 5px;
  border-right: 1px solid #c4c4c4;
  box-sizing: border-box;

  h3,
  h5 {
    color: var(--color-purple);
  }

  .cart-flex-products {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    &.blocked {
      button {
        pointer-events: none;
      }
    }
  }

  .cart-order-budget {
    display: block;
    padding: 0;
  }
`;

export const SelectScheduleContainer = styled.div`
  margin-top: 40px;
  .datetime-result-list {
    margin-top: 30px;
  }

  .container-dates-options.container-times-options {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    box-sizing: border-box;
  }

  .container-times-options {
    margin-top: 30px;
  }

  .available-months {
    margin-top: 30px;
  }

  .error {
    margin-top: 30px;
  }

  .dates-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }

  .text-md {
    font-size: 1.5rem;
  }
`;

export const AttendmentListContainer = styled.div`
  .budget-collect-type {
    display: flex;
    align-items: center;
    gap: 1rem;

    .collect-title {
      color: var(--color-purple);
      margin-bottom: 0;

      & strong {
        font-weight: 600;
      }
    }

    .color-purple {
      color: var(--color-purple);
    }
  }

  .cart-item {
    gap: 5px;
    .action {
      overflow: hidden;
      width: 160px;
      justify-content: space-between;

      .label {
        max-width: unset;
        word-break: break-word;
        max-width: 200px;
      }

      button {
        padding: 0 3px;
      }
    }
  }

  .product-quantity {
    font-family: var(--font-display);
    padding: 0 8px;
  }
`;
